import PlayerHomeV3 from './PlayerHomeV3';

export default PlayerHomeV3;
